import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Slider, Box, Typography, TextField, InputAdornment } from '@mui/material';

CustomMoneyPanel.propTypes = {
  activeFilter: PropTypes.string,
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  maxValue: PropTypes.number,
};

export default function CustomMoneyPanel({ activeFilter, filters, setFilters, maxValue }) {
  const [value, setValue] = useState(filters[activeFilter]?.value || [0, maxValue]);

  useEffect(() => {
    setValue(filters[activeFilter]?.value || [0, maxValue || 10000]);
  }, [activeFilter, filters, maxValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const newFilters =
      newValue[0] === 0 && newValue[1] === maxValue
        ? { ...filters }
        : { ...filters, [activeFilter]: { value: newValue, operator: 'range' } };

    if (newValue[0] === 0 && newValue[1] === maxValue) {
      delete newFilters[activeFilter];
    }

    setFilters(newFilters);
  };

  const handleTextFieldChange = (index, event) => {
    const newValue = [...value];
    newValue[index] = Number(event.target.value);
    setValue(newValue);

    const newFilters =
      newValue[0] === 0 && newValue[1] === maxValue
        ? { ...filters }
        : { ...filters, [activeFilter]: { value: newValue, operator: 'range' } };

    if (newValue[0] === 0 && newValue[1] === maxValue) {
      delete newFilters[activeFilter];
    }

    setFilters(newFilters);
  };

  return (
    <Box>
      <Typography id="range-slider" gutterBottom>
        Price Range
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <TextField
          type="number"
          size="small"
          value={value[0]}
          onChange={(e) => handleTextFieldChange(0, e)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            style: { height: '30px', borderRadius: '4px', border: `solid 1px #404042` },
          }}
          autoComplete="off"
        />
        <Box sx={{ mx: 1 }} />
        <TextField
          type="number"
          size="small"
          value={value[1]}
          onChange={(e) => handleTextFieldChange(1, e)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            style: { height: '30px', borderRadius: '4px', border: `solid 1px #404042` },
          }}
          autoComplete="off"
        />
      </Box>
      <Box sx={{ mt: 1, mx: 1.5 }}>
        <Slider
          value={value}
          onChange={(e, newValue) => setValue(newValue)}
          onChangeCommitted={handleChange}
          valueLabelDisplay="auto"
          aria-labelledby="range-slider"
          min={0}
          max={maxValue || 10000}
          step={maxValue / 100}
        />
      </Box>
    </Box>
  );
}